<template>
  <div class="grid-x grid-padding-x grid-padding-y pega-form">
    <template v-if="$slots.label">
      <slot name="label" />
    </template>
    <div
      v-else-if="label"
      class="medium-3 cell pega-form-label"
    >
      {{ label }}
    </div>
    <div class="auto cell">
      <template v-if="$slots.header">
        <slot name="header" />
      </template>
      <template v-if="!confirm">
        <textarea
          ref="item"
          :value="value"
          :class="className"
          :placeholder="placeholder"
          :rows="rows"
          :cols="cols"
          class="pega-form-item"
          data-test="item"
          @input="update"
        />
        <template v-if="$slots.error">
          <slot name="error" />
        </template>
      </template>
      <template v-else>
        <div class="pega-pre-wrap">
          {{ value }}
        </div>
      </template>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    label: {
      type: String,
      default: ''
    },
    className: {
      type: [String, Array, Object],
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    rows: {
      type: String,
      default: ''
    },
    cols: {
      type: String,
      default: ''
    },
    confirm: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    selectionStart: {
      cache: false,
      get () {
        return this.$refs.item.selectionStart
      }
    }
  },
  methods: {
    update (e) {
      this.$emit('input', e.target.value)
      this.$emit('change', e.target.value)
    }
  }
}
</script>
